import React from "react";

import Header from "../../Components/Header";
import Home_Intro from "../../Components/Home_Intro";
import Right_Pannel from "../../Components/Right_Pannel";
import FeaturedLinks from "../../Components/FeaturedLinks";
import SkillsCarousel from "../../Components/SkillsCarousel";
import ProjectsCarousel from "../../Components/ProjectsCarousel";

function Home() {
  return (
    <>
      {/* SEO META TAGS */}
      <title>Akshat Srivastava | Full Stack & React Developer</title>

      <meta
        name="description"
        content="Akshat Srivastava is a Full Stack & React Developer specializing in scalable web applications, modern UI, and cloud-native solutions."
      />

      <meta
        name="keywords"
        content="Akshat Srivastava, React Developer, Full Stack Developer, JavaScript, Spring Boot, Portfolio"
      />

      <link
        rel="canonical"
        href="https://akshat-srivastava-navy.vercel.app/"
      />

      {/* Open Graph */}
      <meta
        property="og:title"
        content="Akshat Srivastava | Developer Portfolio"
      />
      <meta
        property="og:description"
        content="Explore projects, skills, and experience of Akshat Srivastava, Full Stack & React Developer."
      />
      <meta
        property="og:url"
        content="https://akshat-srivastava-navy.vercel.app/"
      />
      <meta property="og:type" content="website" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />


      {/* UI - UNCHANGED */}
      <div className="bg-default min-h-screen">
        <Header />

        <div className="md:flex md:px-28">
          <div className="flex-1 w-full overflow-hidden">
            <Home_Intro />

            <div className="px-4 pb-4 md:pb-6 mt-4">
              <SkillsCarousel />
            </div>

            <div className="px-4 pb-4 md:pb-6">
              <FeaturedLinks />
            </div>

            <div className="px-4 pb-4 md:pb-6">
              <ProjectsCarousel />
            </div>
          </div>
          <div className="hidden sticky md:block">
            <Right_Pannel />
          </div>
        </div>

        <div className="block md:hidden">
          <Right_Pannel />
        </div>
      </div>
    </>
  );
}

export default Home;
